import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const OrdersComponent = lazy(() => import('./orders.tsx'));

export const ordersRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <OrdersComponent />
      </Suspense>
    )
  }
];
